/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Manual_Record_TitleInputs */

const en_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual Record`)
};

const fr_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement manuel`)
};

const de_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Aufzeichnung`)
};

const it_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione manuale`)
};

const ru_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ручная запись`)
};

const es_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro manual`)
};

const zh_cn2_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动记录`)
};

const ja_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手動記録`)
};

const hi_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैनुअल रिकॉर्ड`)
};

const pt_pt2_voices_manual_record_title = /** @type {(inputs: Voices_Manual_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro manual`)
};

/**
* | output |
* | --- |
* | "Manual Record" |
*
* @param {Voices_Manual_Record_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_manual_record_title = /** @type {((inputs?: Voices_Manual_Record_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Manual_Record_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voices_manual_record_title(inputs)
	if (locale === "de") return de_voices_manual_record_title(inputs)
	if (locale === "it") return it_voices_manual_record_title(inputs)
	if (locale === "ru") return ru_voices_manual_record_title(inputs)
	if (locale === "es") return es_voices_manual_record_title(inputs)
	if (locale === "zh-CN") return zh_cn2_voices_manual_record_title(inputs)
	if (locale === "ja") return ja_voices_manual_record_title(inputs)
	if (locale === "hi") return hi_voices_manual_record_title(inputs)
	if (locale === "pt-PT") return pt_pt2_voices_manual_record_title(inputs)
	return en_voices_manual_record_title(inputs)
});